export default __webpack_public_path__ + "static/media/02.f7e4e26b.jpg";